import React, { useEffect, useState, useContext, useRef } from 'react'
import cssPracticePinyinPronunciation from './PracticePinyinPronunciation.module.scss'
import { LUCacheContext, GoToLUSinceActionEnum } from '../../LearningUnit.js';
// import GoogleShareToClassRoom from '../../../Utils/GShare.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "PracticePinyinPronunciation"
// #endregion Constant

// #region Enumeration
const RowTypeEnum = {
    "None": 0,
    "RowWith3ColumnsWithAudioAndImage": 1, // Row 有 3個Columns 其Column含Image及Audio
    "RowWith4ColumnsWithAudioAndImage": 2, // Row 有 4個Columns 其Column含Image及Audio
    "RowWith4ColumnsWithAudioOnly": 3, // Row 有 4個Columns 其Column只Audio
    "RowWith5ColumnsWithAudioOnly": 4 // Row 有 5個Columns 其Column只Audio
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let mintRowType = RowTypeEnum.None
let mintRowSequenceNumber = 0 // Row左側的編碼數字 有Audio無圖片的Row才有用
let mstrBookCatID = ""
let mobjPlayingAudioIndex = {
    SubCategoryIndex: -1,
    SentenceIndex: -1,
    SentenceItemRowPosition: -1
}
let mstrLUCatSeqNo = ""
// #endregion Member Variables

function PracticePinyinPronunciation(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)

    // #region Init State
    const [,setUpdateDataTime] = useState(0)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region Init Context Ref
    let mobjLUCacheContext = useContext(LUCacheContext) // 包含所有的歷史作答答案
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref
    
    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        console.log("GoToLUSinceActionEnum: ", GoToLUSinceActionEnum)
        console.log("GoToLUSinceAction: ", props.GoToLUSinceAction)
        mintRowType = GetRowType()
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mintRowType = RowTypeEnum.None

            ResetPlayingAudioIndex()

            // 避免離開這個 LU 還收到 Audio Player 的 Callback
            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
            window.AudioLibs.StopAudio()
            mblnInitialized = false
            mrefCleanUp.current()
        }
    }, [props.PathName])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")
        console.log("PaintedMe.mintRowType: ", mintRowType)
        RegisterAudioEvent()
        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
    }
    // #endregion Painted Me

    // #region OnTapHandler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
    }

    function SubSubSectionOnTapHandler(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".SubSubSectionOnTapHandler: ", LUCatSeqNo)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        GoToLU(LUCatSeqNo)
    }

    // #region Google Classroom
    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler
    // #endregion Google Classroom

    function PlayAudioOnTapHandler(AudioFN, SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
    {
        console.log(COMP_NAME + ".PlayAudioOnTapHandler: ", AudioFN, SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)

        let strAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, AudioFN)
        console.log("strAudioUrl: ", strAudioUrl)
        window.AudioLibs.PlayAudio(strAudioUrl)

        SetPlayingAudioIndex(SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
        setUpdateDataTime(new Date().getTime())
    }
    // #endregion OnTapHandler

    // #region Other Handler
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler: ")
        ResetPlayingAudioIndex()
        setUpdateDataTime(new Date().getTime())
    }

    function PlayAudioCanPlayHandler()
    {
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler: ")

        // CloseLoadingMask()
    }
    // #endregion Other Handler

    // #region LoadingMask and Alert
    // function OpenLoadingMask(LoadingMsg)
    // {
    //     console.log("OpenLoadingMask: ", LoadingMsg)

    //     let objCallbackData = {
    //         "Action": "OpenLoadingMask",
    //         "Message": LoadingMsg
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // function CloseLoadingMask()
    // {
    //     console.log(COMP_NAME + ".CloseLoadingMask")

    //     let objCallbackData = {
    //         "Action": "CloseLoadingMask"
    //     }
    //     props.CallbackRef(objCallbackData)
    // }
    // #endregion LoadingMask and Alert

    // #region Toast
    // #endregion Toast

    // #region Component Callback
    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }

	function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    } 

    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }

    function SetPlayingAudioIndex(SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
    {
        console.log(COMP_NAME + ".SetPlayingAudioIndex: ", SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
        mobjPlayingAudioIndex.SubCategoryIndex = parseInt(SubCategoryIndex)
        mobjPlayingAudioIndex.SentenceIndex = parseInt(SentenceIndex)
        mobjPlayingAudioIndex.SentenceItemRowPosition = parseInt(SentenceItemRowPosition)
    }

    function ResetPlayingAudioIndex()
    {
        console.log(COMP_NAME + ".ResetPlayingAudioIndex: ")
        mobjPlayingAudioIndex.SubCategoryIndex = -1
        mobjPlayingAudioIndex.SentenceIndex = -1
        mobjPlayingAudioIndex.SentenceItemRowPosition = -1
    }

    function GoToLU(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GoToLU: ", LUCatSeqNo)

        let objCallbackData = {
            "LUCatSeqNo": LUCatSeqNo,
            "Action": "GoToLU"
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    }

    function GetRowType()
    {
        console.log(COMP_NAME + ".GetRowType: ")
        // 是否有圖片
        let intMaxColumnSize = -1
        let blnHasImage = false
        let intRowType = RowTypeEnum.None

        if(
            (typeof(props.LUInfo.SubCategory) !== "undefined") &&
            (props.LUInfo.SubCategory !== null)
        )
        {
            props.LUInfo.SubCategory.forEach((SubCategoryItem, SubCategoryIndex) => {
                if(
                    (typeof(SubCategoryItem.Sentence) !== "undefined") &&
                    (SubCategoryItem.Sentence !== null)
                )
                {
                    props.LUInfo.SubCategory[SubCategoryIndex].Sentence.forEach((SentenceItem, SentenceIndex) => {
                        if(
                            (typeof(SentenceItem) !== "undefined") &&
                            (SentenceItem !== null)
                        )
                        {
                            if( SentenceItem.length > intMaxColumnSize)
                            {
                                intMaxColumnSize = SentenceItem.length 
                            }
            
                            SentenceItem.forEach((ColumnItem, ColumnIndex) => {
                                // 因為只有 有圖 跟 沒圖 的二種顯示模式 所以只判斷第一個
                                if(
                                    (typeof(ColumnItem.ImgFN) !== "undefined") &&
                                    (ColumnItem.ImgFN !== null)
                                )
                                {
                                    console.log("有圖片的顯示模式")
                                    // 有圖片的顯示模式
                                    blnHasImage = true
                                }
                            })
                        }
                    })
                }
            })
        }
        
        console.log("intMaxColumnSize:", intMaxColumnSize)
        console.log("blnHasImage:", blnHasImage)

        if(blnHasImage)
        {
            // 有圖片的顯示模式
            if(intMaxColumnSize === 3)
            {
                // Row 有 3個Columns 其Column含Image及Audio
                intRowType = RowTypeEnum.RowWith3ColumnsWithAudioAndImage
            }
            else if(intMaxColumnSize === 4)
            {
                // Row 有 4個Columns 其Column含Image及Audio
                intRowType = RowTypeEnum.RowWith4ColumnsWithAudioAndImage
            }
        }
        else
        {
            // 沒有圖片的顯示模式

            if(intMaxColumnSize === 4)
            {
                // Row 有 3個Columns 其Column含Image及Audio
                intRowType = RowTypeEnum.RowWith4ColumnsWithAudioOnly
            }
            else if(intMaxColumnSize === 5)
            {
                // Row 有 4個Columns 其Column含Image及Audio
                intRowType = RowTypeEnum.RowWith5ColumnsWithAudioOnly
            }
        }
        console.log("intRowType: ", intRowType)
        return intRowType
    }

    function GetRowSequenceNumber()
    {
        console.log(COMP_NAME + ".GetTextSequenceNumber: ")
        return mintRowSequenceNumber++
    }

    function ResetRowSequenceNumber()
    {
        console.log(COMP_NAME + ".ResetRowSequenceNumber: ")
        mintRowSequenceNumber = 1
    }
    // #endregion Other Functions

    // #region Get ClassName and Style
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Component
    // #endregion Component

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssPracticePinyinPronunciation.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea")

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        return (
            <>
                <div className={cssPracticePinyinPronunciation.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssPracticePinyinPronunciation.divTitleSubArea}>
                        <div className={cssPracticePinyinPronunciation.divLessonIcon}></div>
                        <div className={cssPracticePinyinPronunciation.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssPracticePinyinPronunciation.divDividerBar}></div>
                        <div className={cssPracticePinyinPronunciation.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function RenderSubSubSectionToolArea()
    {
        console.log(COMP_NAME + ".RenderSubSubSectionToolArea: ");

        return(
            <div className={cssPracticePinyinPronunciation.divSubSubSectionToolArea}>
                <div className={cssPracticePinyinPronunciation.btnPinyinPronunciation} >
                    {props.SubSectionDef.SubSubSection[0].Name}
                </div>
                <div className={cssPracticePinyinPronunciation.btnPinyinIdentification} onClick={() => SubSubSectionOnTapHandler(window.gDCPLUEnum.PracticePinyinIdentification)}>
                    {props.SubSectionDef.SubSubSection[1].Name}
                </div>
                <div className={cssPracticePinyinPronunciation.btnPinyinDictation} onClick={() => SubSubSectionOnTapHandler(window.gDCPLUEnum.PracticePinyinDictation)}>
                    {props.SubSectionDef.SubSubSection[2].Name}
                </div>
            </div>
        )
    }

    function RenderSubSubTitleArea()
    {
        console.log(COMP_NAME + ".RenderSubSubTitleArea: ")

        let strTitleEN = props.SubSectionDef.SubSubSection.find(Item => Item.SubSubSectionSeqNo === props.LUInfo.SubSubSectionSeqNo).Name
        let strTitleCN = ""
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.SubSubSection.find(Item => Item.SubSubSectionSeqNo === props.LUInfo.SubSubSectionSeqNo).MajorName
            console.log("strTitleCN: ", strTitleCN)
        }
        else
        {
            strTitleCN = props.SubSectionDef.SubSubSection.find(Item => Item.SubSubSectionSeqNo === props.LUInfo.SubSubSectionSeqNo).MinorName
            console.log("strTitleCN: ", strTitleCN)
        }

        let strInstruction = props.LUInfo.Instruction.replace(/\n/g, "\r\n")

        return (
            <>
                <div className={cssPracticePinyinPronunciation.divLUSubSubTitleArea}>
                    <div className={cssPracticePinyinPronunciation.divLUSubSubTitleTextEN}>
                        {strTitleEN}
                    </div>
                    <div className={cssPracticePinyinPronunciation.divLUSubSubTitleBar}></div>
                    <div className={cssPracticePinyinPronunciation.divLUSubSubTitleTextCN}>
                        {strTitleCN}
                    </div>
                </div>
                <div className={cssPracticePinyinPronunciation.divLUInstructionText}>
                    {strInstruction}
                </div>
            </>
        )
    }

    function RenderRowName(SubCategoryItem)
    {
        console.log(COMP_NAME + ".RenderRowName: ", SubCategoryItem)
        let strRowName = ""
        if(
            (typeof(SubCategoryItem) !== "undefined") &&
            (SubCategoryItem !== null)
        )
        {
            if (
                (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) &&
                (typeof(SubCategoryItem.MajorName) !== "undefined") &&
                (SubCategoryItem.MajorName !== null)
            )
            {
                strRowName = SubCategoryItem.MajorName
            }
            else if (
                (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Minor) &&
                (typeof(SubCategoryItem.MinorName) !== "undefined") &&
                (SubCategoryItem.MinorName !== null)
            )
            {
                strRowName = SubCategoryItem.MinorName
            }
            console.log("strRowName: ", strRowName)
        }

        let objBlock = null
        if(strRowName !== "")
        {
            if(
                (mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioOnly) ||
                (mintRowType === RowTypeEnum.RowWith5ColumnsWithAudioOnly)
            )
            {
                objBlock = (
                    <div className={cssPracticePinyinPronunciation.divScrollRowNameAudioOnly}>{strRowName}</div>
                )
            }
            else if(
                (mintRowType === RowTypeEnum.RowWith3ColumnsWithAudioAndImage) ||
                (mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioAndImage)
            )
            {
                objBlock = (
                    <div className={cssPracticePinyinPronunciation.divScrollRowNameWithImage}>{strRowName}</div>
                )
            }
        }
        
        return objBlock
    }

    function RenderRowDescription(SubCategoryItem)
    {
        console.log(COMP_NAME + ".RenderRowDescription: ", SubCategoryItem)
        let strRowDescription = ""
        if(
            (typeof(SubCategoryItem) !== "undefined") &&
            (SubCategoryItem !== null)
        )
        {
            if (
                (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) &&
                (typeof(SubCategoryItem.MajorDesc) !== "undefined") &&
                (SubCategoryItem.MajorDesc !== null)
            )
            {
                strRowDescription = SubCategoryItem.MajorDesc
            }
            else if (
                (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Minor) &&
                (typeof(SubCategoryItem.MinorDesc) !== "undefined") &&
                (SubCategoryItem.MinorDesc !== null)
            )
            {
                strRowDescription = SubCategoryItem.MinorDesc
            }
            console.log("strRowDescription: ", strRowDescription)
        }

        let objBlock = null
        if(strRowDescription !== "")
        {
            if(
                (mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioOnly) ||
                (mintRowType === RowTypeEnum.RowWith5ColumnsWithAudioOnly)
            )
            {
                objBlock = (
                    <div className={cssPracticePinyinPronunciation.divScrollRowDescriptionAudioOnly}>{strRowDescription}</div>
                )
            }
            else if(
                (mintRowType === RowTypeEnum.RowWith3ColumnsWithAudioAndImage) ||
                (mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioAndImage)
            )
            {
                objBlock = (
                    <div className={cssPracticePinyinPronunciation.divScrollRowDescriptionWithImage}>{strRowDescription}</div>
                )
            }
        }
        return objBlock
    }

    function GetClsAudioPlayWithAudioOnly(SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
    {
        console.log(COMP_NAME + ".GetClsAudioPlayWithAudioOnly: ", SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
        console.log("GetClsAudioPlayWithAudioOnly.mobjPlayingAudioIndex: ", mobjPlayingAudioIndex)
        let objCls = cssPracticePinyinPronunciation.btnAudioPlayAudioOnly
        
        if(
            (mobjPlayingAudioIndex.SubCategoryIndex === parseInt(SubCategoryIndex)) &&
            (mobjPlayingAudioIndex.SentenceIndex === parseInt(SentenceIndex)) &&
            (mobjPlayingAudioIndex.SentenceItemRowPosition === parseInt(SentenceItemRowPosition))
        )
        {
            console.log("GetClsAudioPlayWithAudioOnly Disable")
            objCls = cssPracticePinyinPronunciation.btnAudioPlayAudioOnlyDisable
        }
        
        return objCls
    }

    function RenderScrollColumnAudioOnly(i, objItem, SubCategoryIndex, SentenceIndex)
    {
        console.log(COMP_NAME + ".RenderScrollColumnAudioOnly: ", i, objItem, SubCategoryIndex, SentenceIndex)
        let strAudioFN = objItem.AudioFN // 避免objItem的object reference導致念的音檔錯誤
        console.log("strAudioFN: ", strAudioFN)
        let strRowPos = objItem.RowPos
        console.log("strRowPos: ", strRowPos)

        return (
            <div key={i} className={cssPracticePinyinPronunciation.divScrollColumnAudioOnly}> 
                <div className={GetClsAudioPlayWithAudioOnly(SubCategoryIndex, SentenceIndex, strRowPos)} onClick={() => PlayAudioOnTapHandler(strAudioFN, SubCategoryIndex, SentenceIndex, strRowPos)}></div>
                <div className={cssPracticePinyinPronunciation.divColumnWithoutIamgePinyin}>{objItem.Pinyin}</div>
            </div>
        )
    }

    function RenderScrollColumnAudioOnlyEmpty(i)
    {
        return (
            <div key={i} className={cssPracticePinyinPronunciation.divScrollColumnAudioOnly}>
                <div className={cssPracticePinyinPronunciation.btnEmptyAudioPlayAudioOnly}></div>
                <div className={cssPracticePinyinPronunciation.divColumnWithoutIamgePinyin}></div>
            </div>
        )
    }

    function RenderSentenceItemForColumnsWithAudioOnly(SentenceItem, SubCategoryIndex, SentenceIndex)
    {
        console.log(COMP_NAME + ".RenderSentenceItemForColumnsWithAudioOnly: ", SentenceItem, SubCategoryIndex, SentenceIndex)
        let arrBlock = []

        if(
            (typeof(SentenceItem) !== "undefined") &&
            (SentenceItem !== null)
        )
        {    
            let intColumnCount = 0
            if(mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioOnly)
            {
                intColumnCount = 4 // 一個Row有4個Columns
            }
            else if(mintRowType === RowTypeEnum.RowWith5ColumnsWithAudioOnly)
            {
                intColumnCount = 5 // 一個Row有5個Columns
            }
            
            let i
            for(i = 1; i <= intColumnCount ; i++)
            {
                let intCurrentPos = i
                let objItem = SentenceItem.find(Item => parseInt(Item.RowPos) === intCurrentPos)
                
                console.log("i: ", i)
                console.log("objItem:", objItem)
                if(
                    (typeof(objItem) !== "undefined") &&
                    (objItem !== null)
                    )
                {
                    arrBlock.push(RenderScrollColumnAudioOnly(i, objItem, SubCategoryIndex, SentenceIndex))
                }
                else
                {
                    // 為了排版時 產生一樣大小的空Column
                    arrBlock.push(RenderScrollColumnAudioOnlyEmpty(i))
                }
            }
        }
        return arrBlock
    }

    function GetClsAudioPlayWithImage(SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
    {
        console.log(COMP_NAME + ".GetClsAudioPlayWithImage: ", SubCategoryIndex, SentenceIndex, SentenceItemRowPosition)
        console.log("GetClsAudioPlayWithImage.mobjPlayingAudioIndex: ", mobjPlayingAudioIndex)
        let objCls = cssPracticePinyinPronunciation.btnAudioPlayWithImage
        
        if(
            (mobjPlayingAudioIndex.SubCategoryIndex === parseInt(SubCategoryIndex)) &&
            (mobjPlayingAudioIndex.SentenceIndex === parseInt(SentenceIndex)) &&
            (mobjPlayingAudioIndex.SentenceItemRowPosition === parseInt(SentenceItemRowPosition))
        )
        {
            console.log("AudioPlay Disable")
            objCls = cssPracticePinyinPronunciation.btnAudioPlayWithImageDisabled
        }
        
        return objCls
    }

    function RenderScrollColumnWithImage(i, objItem, SubCategoryIndex, SentenceIndex)
    {
        console.log(COMP_NAME + ".RenderScrollColumnWithImage: ", i, objItem, SubCategoryIndex, SentenceIndex)
        let strAudioFN = objItem.AudioFN // 避免objItem的object reference導致念的音檔錯誤
        console.log("strAudioFN: ", strAudioFN)
        let strRowPos = objItem.RowPos
        console.log("strRowPos: ", strRowPos)

        let strImageUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image, objItem.ImgFN)
        console.log("strImageUrl: ", strImageUrl)

        let objStyleImage = {
            backgroundImage: 'url(' + strImageUrl + ')'
        } 

        let strText = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? objItem.MajorText : objItem.MinorText

        return (
            <div key={i} className={cssPracticePinyinPronunciation.divScrollColumnWithImage}> 
                <div className={cssPracticePinyinPronunciation.divImage} style={objStyleImage}></div>
                <div className={GetClsAudioPlayWithImage(SubCategoryIndex, SentenceIndex, strRowPos)} onClick={() => PlayAudioOnTapHandler(strAudioFN, SubCategoryIndex, SentenceIndex, strRowPos)}></div>
                <div className={cssPracticePinyinPronunciation.divScrollColumnWithImagePinyin}>{objItem.Pinyin}</div>
                <div className={cssPracticePinyinPronunciation.divScrollColumnWithImageText}>{objItem.Text}{" ("}{strText}{")"}</div>
            </div>
        )
    }

    function RenderSentenceItemForColumnsWithAudioAndImage(SentenceItem, SubCategoryIndex, SentenceIndex)
    {
        console.log(COMP_NAME + ".RenderSentenceItemForColumnsWithAudioAndImage: ", SentenceItem, SubCategoryIndex, SentenceIndex)
        
        let arrBlock = []
        if(
            (typeof(SentenceItem) !== "undefined") &&
            (SentenceItem !== null)
        )
        {
            let intColumnCount = 0
            if(mintRowType === RowTypeEnum.RowWith3ColumnsWithAudioAndImage)
            {
                intColumnCount = 3 // 一個Row有3個Columns
            }
            else if(mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioAndImage)
            {
                intColumnCount = 4 // 一個Row有4個Columns
            }

            let i
            for(i = 1; i <= intColumnCount ; i++)
            {
                let intCurrentPos = i
                let objItem = SentenceItem.find(Item => parseInt(Item.RowPos) === intCurrentPos)

                console.log("i: ", i)
                console.log("objItem:", objItem)
                if(
                    (typeof(objItem) !== "undefined") &&
                    (objItem !== null)
                    )
                {
                    arrBlock.push(RenderScrollColumnWithImage(i, objItem, SubCategoryIndex, SentenceIndex))
                }
                else
                {
                    // 為了排版時 產生一樣大小的空Column
                    arrBlock.push(
                        <div key={i} className={cssPracticePinyinPronunciation.divScrollEmptyColumnWithImage}></div>
                    )
                }
            }
        }
        return arrBlock
    }

    function RenderSentence(SubCategoryIndex)
    {
        console.log(COMP_NAME + ".RenderSentence: ", SubCategoryIndex)
        console.log("props.LUInfo.SubCategory[SubCategoryIndex]: ", props.LUInfo.SubCategory[SubCategoryIndex])
        let objBlock = null
        if(
            (typeof(props.LUInfo.SubCategory[SubCategoryIndex].Sentence) !== "undefined") &&
            (props.LUInfo.SubCategory[SubCategoryIndex].Sentence !== null)
        )
        {
            console.log("RenderSentence.mintRowType: ", mintRowType)
            if(
                (mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioOnly) ||
                (mintRowType === RowTypeEnum.RowWith5ColumnsWithAudioOnly)
            )
            {
                let objRowName = RenderRowName(props.LUInfo.SubCategory[SubCategoryIndex])
                let objRowDescription = RenderRowDescription(props.LUInfo.SubCategory[SubCategoryIndex])
                console.log("RowWith4ColumnsWithAudioOnly or RowWith5ColumnsWithAudioOnly")
                console.log("mintRowSequenceNumber: ", mintRowSequenceNumber)
                
                objBlock = (
                    <React.Fragment key={SubCategoryIndex}>
                    {objRowName}
                    {objRowDescription}
                    {props.LUInfo.SubCategory[SubCategoryIndex].Sentence.map((SentenceItem, SentenceIndex) =>
                        <div key={SentenceIndex} className={cssPracticePinyinPronunciation.divScrollRowAudioPlayAudioOnly}>
                            <div className={cssPracticePinyinPronunciation.divCellSequenceNumber}>{GetRowSequenceNumber()}{"."}</div>
                            {RenderSentenceItemForColumnsWithAudioOnly(SentenceItem, SubCategoryIndex, SentenceIndex)}
                        </div>
                    )}
                    </React.Fragment>
                )
            }
            else if(
                (mintRowType === RowTypeEnum.RowWith3ColumnsWithAudioAndImage) ||
                (mintRowType === RowTypeEnum.RowWith4ColumnsWithAudioAndImage)
            )
            {
                console.log("RowWith3ColumnsWithAudioAndImage or RowWith4ColumnsWithAudioAndImage")
                let objRowName = RenderRowName(props.LUInfo.SubCategory[SubCategoryIndex])
                let objRowDescription = RenderRowDescription(props.LUInfo.SubCategory[SubCategoryIndex])
                objBlock = (
                    <>
                    {objRowName}
                    {objRowDescription}
                    {props.LUInfo.SubCategory[SubCategoryIndex].Sentence.map((SentenceItem, SentenceIndex) =>
                        <div key={SentenceIndex} className={cssPracticePinyinPronunciation.divScrollRowWithImage}>
                            {RenderSentenceItemForColumnsWithAudioAndImage(SentenceItem, SubCategoryIndex, SentenceIndex)}
                        </div>
                    )}
                    </>
                )

            }
        }
        return objBlock
    }

    function RenderScrollArea()
    {
        console.log(COMP_NAME + ".RenderScrollArea: ")
        console.log("RenderScrollArea.mobjPlayingAudioIndex: ", mobjPlayingAudioIndex)

        ResetRowSequenceNumber()
        return (
            <div className={cssPracticePinyinPronunciation.divSubContentArea}>
                {props.LUInfo.SubCategory.map((SubCategoryItem, SubCategoryIndex) =>
                    RenderSentence(SubCategoryIndex)
                )}
            </div>
        )
    }

    function RenderContent()
    {
        console.log(COMP_NAME + ".RenderContent: ")
        return (
            <>
                <div className={cssPracticePinyinPronunciation.divContentArea}>
                    {RenderSubSubTitleArea()}
                    {RenderScrollArea()}
                </div>
            </>
        )
    }

    return (
        <>
            {RenderHeaderLeftArea()}
            {RenderSubSubSectionToolArea()}
            {RenderContent()}
        </>
    )
    // #endregion Render
}
export default PracticePinyinPronunciation